export const useHasErrors = (requiredProps, props) => {
  const errors = (requiredProps || []).map(requiredProp => {
    return props[requiredProp] === undefined || props[requiredProp] === null;
  });
  return errors.filter(error => !!error).length > 0;
};